const API_BASE = '/admin/settings';

export async function getSettings() {
  return fetch(API_BASE, { method: 'GET' });
}

// Public read of a single setting value, e.g. for use outside the admin area.
export async function getPublicSetting(key) {
  return fetch(`/settings/${key}`, { method: 'GET' });
}

export async function updateSetting(key, value) {
  return fetch(`${API_BASE}/${key}`, {
    method: 'PUT',
    body: JSON.stringify({ value }),
  });
}
